
import Vue from 'vue';
import IllinoisIcons from './icons.vue';
import { useApiV3 } from '@/composables/apiV3';
import store from '@/store';
import icons from './icons.vue';
import useI18n from 'vue-i18n';

type SearchResultItem = {
  title?: string;
  subtitle?: string;
  scheduled?: string | number | Date;
  id?: string;
  [key: string]: any;
};

export default Vue.extend({
  name: 'SearchBar',
  components: { IllinoisIcons, icons },
  data() {
    return {
      isOpen: false as boolean,
      searchQuery: '' as string,
      results: [] as SearchResultItem[],
      loading: false as boolean,

      debounceTimer: null as number | null
    };
  },
  methods: {
    t(key: string, values?: Record<string, unknown> | any[]) {
      return this.$t(key, values) as string;
    },

    openModal(): void {
      this.isOpen = true;
      this.$nextTick(() => {
        const el = this.$refs.searchInputRef as HTMLInputElement | undefined;
        if (el) {
          el.focus();
        }
      });
    },
    closeModal(): void {
      this.isOpen = false;
      this.searchQuery = '';
      this.results = [];
      this.loading = false;
    },
    clearQuery(): void {
      this.searchQuery = '';
      this.results = [];
    },
    async runSearch(): Promise<void> {
      const q = this.searchQuery.trim();
      if (q.length < 3) {
        this.results = [];
        this.loading = false;
        return;
      }
      this.loading = true;
      try {
        const { findEvents } = useApiV3();
        const response: any = await findEvents({ search: q });
        this.results = (response && response.events) || [];
      } catch (e) {
        this.results = [];
      } finally {
        this.loading = false;
      }
    },
    formatDate(v: any): string {
      try {
        const d = new Date(v);
        return d.toLocaleDateString(store.getters['settings/getLanguage']);
      } catch (e) {
        return '';
      }
    },
    formatTime(v: any): string {
      try {
        const d = new Date(v);
        return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
      } catch (e) {
        return '';
      }
    }
  },
  watch: {
    searchQuery() {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }
      this.debounceTimer = window.setTimeout(() => this.runSearch(), 300);
    }
  },
  mounted() {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && this.isOpen) this.closeModal();
    };
    window.addEventListener('keydown', onKey);
  }
});
